// Core packages
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

// Third party packages
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

// Custom packages
import { EnvironmentService } from 'src/app/shared/services/environment.service';

@Injectable({
  providedIn: 'root'
})
export class LangGuard implements CanActivate {

  /**
   * Class constructor
   */
  constructor(
    private router: Router,
    private translateService: TranslateService,
    private cookieService: CookieService,
    private environmentService: EnvironmentService
  ) { }

  /**
   * Handle guard logic
   *
   * @since 1.0.0
   *
   * @param route Snapshot of activated route
   */
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const lang = route.params.lang;
    const langs = this.translateService.getLangs();
    if (langs.includes(lang)) {
      this.cookieService.delete('lang');
      this.cookieService.set(
        'lang',
        lang,
        365,
        '/',
        this.environmentService.getFrontEndHost(),
        this.environmentService.getFrontEndCookieSecure(),
        'Strict'
      );
      this.translateService.use(lang);
      return true;
    }
    this.router.navigate(['it', 'errors', '404']);
    return false;
  }
}
